import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Edit } from "@material-ui/icons";
import { currencyFormat, monthWithPrefix } from "./../../Common/Common";
import * as code from "./../../../config/Constants";
import { REACT_APP_RECAPTCHA } from "./../../../config/Constants";
import ReCAPTCHA from "react-google-recaptcha";

class Review extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: props.getUserData(),
    };
  }

  /**
   * @desc jump to other step for edit information
   */
  stepChange(step) {
    this.props.jumpToStep(step);
  }

  render() {
    //console.log("adsf",this.state.user)
    return (
      <div className="step-content last-step">
        <Row>
          <Col>
            <h4 className="title-blue mb-3">Personal Information</h4>
          </Col>
          <Col className="col-auto">
            <Button
              variant="transparent"
              className="edit-icn p-0"
              onClick={() => this.stepChange(0)}
            >
              <Edit />
            </Button>
          </Col>
        </Row>

        <Form className="form-sm">
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Username</Form.Label>
                <p className="form-val">{this.state.user.username}</p>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>First Name</Form.Label>
                <p className="form-val">{this.state.user.firstname}</p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Last Name</Form.Label>
                <p className="form-val">{this.state.user.lastname}</p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Email</Form.Label>
                <p className="form-val email-case">{this.state.user.email}</p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Recovery Email</Form.Label>
                <p className="form-val email-case">
                  {this.state.user.recoveryEmail}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Create Password</Form.Label>
                <p className="form-val">******</p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Confirm Password</Form.Label>
                <p className="form-val">******</p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Mobile No.</Form.Label>
                <p className="form-val">{this.state.user.mobileNumber}</p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Phone No. (Office)</Form.Label>
                <p className="form-val">
                  {this.state.user.otherNumber !== ""
                    ? this.state.user.otherNumber
                    : "-"}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>How did you hear about us?</Form.Label>
                <p className="form-val">
                  {this.state.user.knowAboutUs !== ""
                    ? this.state.user.knowAboutUs
                    : "-"}
                </p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Referral Code</Form.Label>
                <p className="form-val">
                  {this.state.user.referralCode !== ""
                    ? this.state.user.referralCode
                    : "-"}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Facebook URL</Form.Label>
                <p className="form-val">
                  {this.state.user.socialMediaHandles.facebook}
                </p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Instagram URL</Form.Label>
                <p className="form-val">
                  {this.state.user.socialMediaHandles.twitter}
                </p>
              </Form.Group>
            </Col>
          </Row>
        </Form>

        <Row className="mt-2">
          <Col>
            <h4 className="title-blue mb-3">Studio Information</h4>
          </Col>
          <Col className="col-auto">
            <Button
              variant="transparent"
              className="edit-icn p-0"
              onClick={() => this.stepChange(1)}
            >
              <Edit />
            </Button>
          </Col>
        </Row>

        <Form className="form-sm">
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Studio Name</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.name}
                </p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Website</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.website !== ""
                    ? this.state.user.companyInformation.website
                    : "-"}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Address</Form.Label>
                <p className="form-val email-case">
                  {this.state.user.companyInformation.address}
                </p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>City</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.city}
                </p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>State</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.state}
                </p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Zip Code</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.zipcode}
                </p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Phone Number</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.phoneNumber}
                </p>
              </Form.Group>
            </Col>
          </Row>

          {localStorage.getItem(code.IS_BILLING_ENABLED) === "true" ? (
            <>
              {/* <Row>
                <Col>
                  <h4 className="title-blue mb-3">Plan Information</h4>
                </Col>
                <Col className="col-auto">
                  <Button
                    variant="transparent"
                    className="edit-icn p-0"
                    onClick={() => this.stepChange(2)}
                  >
                    <Edit />
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Product Name</Form.Label>
                    <p className="form-val">{this.state.user.productName}</p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Billing Period</Form.Label>
                    <p className="form-val">
                      {this.state.user.interval === "month"
                        ? "Monthly"
                        : "Yearly"}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Total Price</Form.Label>
                    <p className="form-val">
                      {currencyFormat(this.state.user.amount)}
                    </p>
                  </Form.Group>
                </Col>
              </Row> */}
              <Row>
                <Col>
                  <h4 className="title-blue mb-3">Billing Information</h4>
                </Col>
                <Col className="col-auto">
                  <Button
                    variant="transparent"
                    className="edit-icn p-0"
                    //onClick={() => this.stepChange(3)}
                    onClick={() => this.stepChange(2)}
                  >
                    <Edit />
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <Form.Group controlId="">
                    <Form.Label>First Name</Form.Label>
                    <p className="form-val">
                      {this.state.user.billingAddress.firstname}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Group controlId="">
                    <Form.Label>Last Name</Form.Label>
                    <p className="form-val">
                      {this.state.user.billingAddress.lastname}
                    </p>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Address Line 1</Form.Label>
                    <p className="form-val">
                      {this.state.user.billingAddress.addressLine1}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Address Line 2</Form.Label>
                    <p className="form-val">
                      {this.state.user.billingAddress.addressLine2}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Phone Number</Form.Label>
                    <p className="form-val">
                      {this.state.user.billingAddress.phoneNumber}
                    </p>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Zip Code</Form.Label>
                    <p className="form-val">
                      {this.state.user.billingAddress.zip}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>City</Form.Label>
                    <p className="form-val">
                      {this.state.user.billingAddress.city}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>State</Form.Label>
                    <p className="form-val">
                      {this.state.user.billingAddress.state}
                    </p>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h4 className="title-blue mb-3">Payment Information</h4>
                </Col>
                <Col className="col-auto">
                  <Button
                    variant="transparent"
                    className="edit-icn p-0"
                    //onClick={() => this.stepChange(4)}
                    onClick={() => this.stepChange(3)}
                  >
                    <Edit />
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Card Number</Form.Label>
                    <p className="form-val">
                      {"****" + this.state.user.paymentMethods.number}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Brand</Form.Label>
                    <p className="form-val">
                      {this.state.user.paymentMethods.brand}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Expiry</Form.Label>
                    <p className="form-val">
                      {monthWithPrefix(
                        this.state.user.paymentMethods.expireMonth
                      ) +
                        "/" +
                        this.state.user.paymentMethods.expireYear}
                    </p>
                  </Form.Group>
                </Col>
              </Row>
            </>
          ) : (
            ""
          )}
        </Form>
        <ReCAPTCHA
          onChange={this.props.handleRecaptchaCheck}
          sitekey={REACT_APP_RECAPTCHA}
        />
      </div>
    );
  }
}

export default Review;
